import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pt-8 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "space-y-6 ml-4" }
const _hoisted_3 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_4 = { class: "text-black-lp-300 flex py-2" }
const _hoisted_5 = { class: "rounded px-2 py-0 bg-gray-lp-400" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "py-3 pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_7 = { class: "py-3 ml-4 pr-6" }
const _hoisted_8 = { class: "flex capitalize mt-1" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "overflow-ellipsis text-left" }
const _hoisted_11 = { class: "truncate text-gray-lp-600 w-32" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Title = _resolveComponent("Title")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumb),
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      customClass: "px-0",
      onBack: _ctx.goBack,
      title: "DTPOL",
      loading: _ctx.isLoading,
      error: !!_ctx.errorCause,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.fetchDetailData
    }, {
      data: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              class: "w-full",
              label: "Produk"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, _toDisplayString(_ctx.detailData.product), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "w-3/4",
              label: "Deskripsi",
              value: _ctx.detailData.description
            }, null, 8, ["value"])
          ])
        ]),
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_Title, { label: "Parameter Perhitungan Komisi" }),
          _createVNode(_component_TableV2, {
            data: _ctx.detailData.commissions,
            columns: _ctx.columns,
            pagination: _ctx.pagination,
            hidePagination: "",
            borderTop: false,
            borderBottom: false
          }, null, 8, ["data", "columns", "pagination"])
        ])
      ]),
      "sub-data": _withCtx(() => [
        _createVNode(_component_DataWrapper, {
          class: "w-full",
          label: "Status Komisi"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", {
                class: _ctx.onChipStatus(_ctx.detailData.status)
              }, _toDisplayString(_ctx.detailData.status), 3)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          class: "w-full",
          label: "Tanggal Diubah"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.formatDateWithoutTime(_ctx.detailData.updatedAt)) + " ", 1),
                _createVNode("div", _hoisted_11, _toDisplayString(_ctx.detailData.updatedBy), 1)
              ])
            ])
          ]),
          _: 1
        }),
        (_ctx.ableToEdit)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 0,
              title: "Ubah",
              onClick: _ctx.goToEdit,
              textColor: "white"
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onBack", "loading", "error", "errorType", "onTryAgain"])
  ]))
}